import React from 'react'
import {SideBar} from './SideBar'

export const BasicLayout = (props: any) => {
  const {children} = props
  return (
    <div>
      <SideBar>{children}</SideBar>
    </div>
  )
}
